import { Divider } from "@mui/material";

import type { FC } from "react";

export const ThemeAwareDivider: FC = () => <Divider sx={{ borderColor: "sidebar.divider" }} />;
